import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import api from '@/services/api';
import { toast } from 'sonner';

// Lands here after Google OAuth: backend redirects to /auth/callback#token=<jwt>.
export default function GoogleCallbackPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const token = params.get('token');
    if (!token) {
      toast.error('Google sign-in failed');
      navigate('/login');
      return;
    }

    (async () => {
      try {
        localStorage.setItem('access_token', token); // so the api interceptor attaches it
        const { data: user } = await api.get('/auth/me');
        login(token, user, true);
        toast.success('Signed in with Google');
        if (user.role === 'stylist') navigate('/stylist/dashboard');
        else if (user.role === 'admin') navigate('/admin');
        else navigate('/services');
      } catch (e) {
        localStorage.removeItem('access_token');
        toast.error('Google sign-in failed');
        navigate('/login');
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="h-12 w-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
